import React, { useEffect, useState, useCallback } from 'react';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

import { API_BASE_URL } from '../config';

const mapContainerStyle = {
  width: '100%',
  height: '500px'
};

const center = {
  lat: 36.752887,
  lng: 3.042048
};

const DriversMap = () => {
  const [drivers, setDrivers] = useState([]);

  const fetchDrivers = useCallback(async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/admin/location`);
      const data = await response.json();
      if (data.success) {
        // Parse latitude and longitude to numbers, filter out invalid ones
        const validDrivers = data.drivers
          .filter(driver => driver.latitude && driver.longitude) // Filter out null values
          .map(driver => ({
            id: driver.id,
            latitude: parseFloat(driver.latitude),
            longitude: parseFloat(driver.longitude), 
            car: driver.car,
          }));
        setDrivers(validDrivers);
      } else {
        console.error('Failed to fetch drivers:', data.message);
      }
    } catch (error) {
      console.error('Error fetching drivers:', error);
    }
  }, []);

  useEffect(() => {
    fetchDrivers();
    const interval = setInterval(fetchDrivers, 10000); // Fetch drivers every 10 seconds
    return () => clearInterval(interval);
  }, [fetchDrivers]);

return (
        <GoogleMap
            mapContainerStyle={mapContainerStyle}
            center={center}
            zoom={8}
        >
            {drivers.map(driver => (
                <Marker
                    key={driver.id}
                    position={{ lat: driver.latitude, lng: driver.longitude }}
                    icon={{
                        url: `/assets/cars/${driver.car}.png`,
                        scaledSize: new window.google.maps.Size(52, 32), // Customize marker icon size
                    }}
                />
            ))}
        </GoogleMap>
);
};

export default DriversMap;
